import request from "../../config/axios";

const getActivePopup = () => {
  return request.get("/wp-json/lianne-popup/v1/active");
};

const getWpformsHtml = (formId) => {
  return request.get(`/wp-json/lianne-popup/v1/wpforms/${formId}`);
};

export { getActivePopup, getWpformsHtml };
